import '../index.css';
var styles = {
  "option": "bp_checkbox_module_option--1bc1f",
  "checkbox": "bp_checkbox_module_checkbox--1bc1f",
  "indicator": "bp_checkbox_module_indicator--1bc1f",
  "label": "bp_checkbox_module_label--1bc1f",
  "description": "bp_checkbox_module_description--1bc1f",
  "disabled": "bp_checkbox_module_disabled--1bc1f"
};
export { styles as default };